if($('.type-detail').length){
    $(document).ready(updatePriceSaveStateOnLoad);
    $(document).ready(function () {
        initQuantityDiscountInfo($('.p-info-wrapper'));
    });
    const $availability = $('.availability-value');
    var availabilityText = $availability.text();

    var shouldActivate = stavyNaZony.some(function(state) {
        return availabilityText.includes(state);
    });

    if (shouldActivate) {
        const $infoWrapper = $('.p-info-wrapper');

        if (!$infoWrapper.find('.infoTree').length) {
            $infoWrapper.append($('footer#footer .infoTree'));
        }

        if (!$infoWrapper.find('.infoTreeDelivery').length) {
            $infoWrapper.append($('footer#footer .infoTreeDelivery'));
        }
    }
    else{

    }
   


    $('li[data-testid="tabDescription"] a').text(translation('popisProduktu'))
    if($('.p-final-price-wrapper .price-save').length){
        var $def = $('.p-final-price-wrapper .price-save');
        var html = $def.html();
        html = html.replace(/až/gi, '<span class="small">až</span>');
        $def.html(html);
    }
    $('.extended-description').wrapInner('<div class="extendedParams"></div>');
   $(function () {
    const $extended = $('.extended-description');
    const $rows = $extended.find('.detail-parameters tr');

    let propertiesText = null;
    let guideText = null;
    let guideUrl = null;
    const collectedRows = {};
    $rows.each(function () {
        const $row = $(this);
        const label = $row.find('th').text().trim();
        const labelKey = $row.find('th .row-header-label').clone().children().remove().end().text().replace(':', '').trim();
        const hasLink = $(this).find('td a').length > 0;
        const isCategory = labelKey === 'Kategorie';

        // NÁVOD NA PĚSTOVÁNÍ
        if (label.startsWith(translation('navodnapestovani'))) {
            const raw = $row.find('td').text().trim();

            // očekávaný formát: Text - /url
            const parts = raw.split(' - ');
            if (parts.length === 2) {
                guideText = parts[0].trim();
                guideUrl = parts[1].trim();
            }

            $row.hide();
        }
   
        if (hasLink && !isCategory) {
            $row.hide();
            return;
        }

        if (visibleParams.includes(labelKey)) {
            if (!collectedRows[labelKey]) {
                collectedRows[labelKey] = $row.detach();
            }
            return;
        }
       
        
        $row.hide();

    });
    visibleParams.forEach(labelKey => {
    if (collectedRows[labelKey]) {
        $('.detail-parameters').append(collectedRows[labelKey].show());
    }
    });
    if (propertiesText) {
        const properties = propertiesText.split(',').map(p => p.trim());
        const $wrapper = $('<div class="topParameters"></div>');
        const $ul = $('<ul class="parameters"></ul>');
        properties.forEach(prop => {
            const slug = slugify(prop);
            let text = prop;

            if (prop.toLowerCase().startsWith('výška')) {
                text = prop.replace(/výška\s*/i, '');
            }
            if (prop.toLowerCase().startsWith('šířka')) {
                text = prop.replace(/šířka\s*/i, '');
            }
            const $li = $(`
                <li class="property property-${slug}">
                    <span class="property-icon">
                        <img src="/user/documents/upload/detail/top-vlastnosti/${slug}.svg" alt="${prop}">
                    </span>
                    <span class="property-text">${text}</span>
                </li>
            `);

            $ul.append($li);
        });

        $wrapper.append($ul);
        $extended.prepend($wrapper);
    }
    if (guideText && guideUrl) {
        const $guideBtn = $(`
            <div class="plantingGuide">
                <a href="${guideUrl}" class="plantingGuideBtn btn btn-primary">
                    ${guideText}
                </a>
            </div>
        `);
        $extended.append($guideBtn);
    }
});



    var flags = $('.product-top>.col-xs-12:not(.col-lg-6) .flags').html() || '';
    var topTitle = $('.p-detail>.p-detail-inner>.p-detail-inner-header h1').html();
    var topCode = $('.p-detail>.p-detail-inner>.p-detail-inner-header .p-code').html();
    var customInfoWrapper = `
        <div class="customFlags flags-default flags">${flags}</div>
        <div class="h1">${topTitle}</div>
        <div class="customCode">${topCode}</div>
        <div class="customCart"></div>
    `;
    $('.p-image').append(`<div class="customFlags flags-default flags">${flags}</div>`)
    $('.p-info-wrapper').append(customInfoWrapper);
    $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'), $('.p-info-wrapper .add-to-cart'));
    if($('.p-info-wrapper .detail-parameters .sold-out').length){
        $('.customCart').append('<div class="soldOut">'+$('.p-info-wrapper .detail-parameters .sold-out').text()+'</div>')
    }
    if ($('#simple-variants').length) {
        createStockInfoBlock();
        renderChooseVariants();
        updateStockInfo();
    }
    if($('.shipping-options').length){
        $('.customStockLine .right .delivery-link').append($('.shipping-options'));
    };
   /* if ($('.p-thumbnails-wrapper .p-thumbnails-inner').length) {
        $('.p-image-wrapper').addClass('haveThumbnails');
        $('.p-image-wrapper').append('<span class="arrow-prev"></span><span class="arrow-next"></span>');
        $('body').on('click', '.arrow-prev, .arrow-next', function () {
            var thumbnails = $('.p-thumbnails-inner').find('a.p-thumbnail, a.p-video-thumbnail, a.show360image');
            var highlightedThumbnail = $('.p-thumbnails-inner').find('a.highlighted');
            var isNext = $(this).hasClass('arrow-next');
            var totalThumbnails = thumbnails.length;
            var currentIndex = thumbnails.index(highlightedThumbnail);
            thumbnails.removeClass('highlighted');
            if (highlightedThumbnail.length === 0) {
                highlightedThumbnail = isNext ? thumbnails.first() : thumbnails.last();
            } else {
                currentIndex = isNext ? (currentIndex + 1) % totalThumbnails : (currentIndex - 1 + totalThumbnails) % totalThumbnails;
                highlightedThumbnail = thumbnails.eq(currentIndex);
            }
            highlightedThumbnail.addClass('highlighted');
            setTimeout(function () {
                updateMainImage(highlightedThumbnail);
            }, 10);
        });

       $(function () {
            const maxVisible = 3;
            const $thumbs = $('.p-thumbnail img');
            const total = $thumbs.length;
            $thumbs.each(function () {
                const $img = $(this);
                const src = $img.attr('data-src');
                if (src && src.includes('/related/')) {
                    const origSrc = src.replace('/related/', '/orig/');
                    $img.attr('data-src', origSrc);
                }
            });
            $thumbs.slice(maxVisible+1).closest('a.p-thumbnail').hide();
            if (total > maxVisible) {
                const hiddenCount = total - maxVisible;
                const label = sklonujFotky(hiddenCount);
                const $btn = $(`
                    <span class="morePhotosBtn">
                        + ${hiddenCount} ${label}
                    </span>
                `);
                $thumbs.eq(maxVisible).closest('a.p-thumbnail').addClass('lastImage').html($btn);
                $btn.on('click', function (e) {
                    e.preventDefault();
                    $thumbs.eq(maxVisible).trigger('click');
                });
            }
        });


    }*/
$(function () {
    const $wrapper = $('.p-image-wrapper').first();
    const $main = $wrapper.find('.p-image').first();
    const $mainLink = $main.find('a.p-main-image').first();

    if (!$mainLink.length) return;

    // Vyhledání parametru video, i když je jeho řádek skrytý.
    const $videoRow = $('#description .detail-parameters tr').filter(function () {
        const name = $(this)
            .find('th .row-header-label')
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .replace(/:/g, '')
            .trim()
            .toLowerCase();

        return name === 'video';
    }).first();

    const videoSrc = $videoRow.find('td').text().trim();
    const $tooltip = $videoRow.find('.show-tooltip').first();
    const videoPoster = (
        $tooltip.attr('data-original-title') ||
        $tooltip.attr('title') ||
        ''
    ).trim();

    let $inner = $wrapper.find('.p-thumbnails-inner').first();

    if (videoSrc) {
        $videoRow.hide();

        // Produkt nemá galerii: vytvoříme její obal.
        if (!$inner.length) {
            const $gallery = $(`
                <div class="p-thumbnails-wrapper">
                    <div class="p-thumbnails p-thumbnails-horizontal">
                        <div class="p-thumbnails-inner">
                            <div></div>
                        </div>
                    </div>
                </div>
            `);

            $main.after($gallery);
            $inner = $gallery.find('.p-thumbnails-inner');
        }

        let $items = $inner.children('div').first();

        if (!$items.length) {
            $items = $('<div></div>').appendTo($inner);
        }

        // Původní hlavní fotografii zachováme jako náhled.
        if (!$inner.find('a.p-thumbnail').length) {
            const $originalImg = $mainLink.find('img').first();
            const photoSrc =
                $mainLink.attr('href') || $originalImg.attr('src');

            const $photoThumb = $('<a></a>').attr({
                href: photoSrc,
                class: 'p-thumbnail',
                'data-alt': $originalImg.attr('alt') || '',
                'data-full-image': $mainLink.attr('data-href') || photoSrc
            });

            $('<img>').attr({
                src: $originalImg.attr('src') || photoSrc,
                alt: $originalImg.attr('alt') || '',
                width: 100,
                height: 100,
                loading: 'lazy'
            }).appendTo($photoThumb);

            $items.append($photoThumb);
        }

        // Video má vlastní třídu, aby se nepočítalo mezi fotografie.
        if (!$inner.find('.p-video-thumbnail').length) {
            const $videoThumb = $('<a></a>').attr({
                href: $mainLink.attr('href') || $mainLink.find('img').attr('src'),
                class: 'p-video-thumbnail p-thumbnail',
                'aria-label': 'Zobrazit video',
                'data-video-src': videoSrc,
                'data-video-poster': videoPoster
            });

            const $previewVideo = $('<video></video>').attr({
    src: videoSrc,
    autoplay: true,
    muted: true,
    loop: true,
    playsinline: true,
    preload: 'metadata'
});

if (videoPoster) {
    $previewVideo.attr('poster', videoPoster);
}

const previewVideo = $previewVideo[0];

previewVideo.muted = true;
previewVideo.defaultMuted = true;
previewVideo.autoplay = true;
previewVideo.loop = true;
previewVideo.playsInline = true;

$videoThumb.append($previewVideo);
$items.prepend($videoThumb);

previewVideo.play().catch(function (error) {
    console.warn('Přehrávání náhledu videa:', error);
});

            $('<span class="video-play-icon" aria-hidden="true">▶</span>')
                .appendTo($videoThumb);

        }
    }

    if (!$('.product-top .flag-blok-recenze').length) {
        const product = getShoptetDataLayer('product');
        const sku = product && product.codes && product.codes[0]
            ? product.codes[0].code
            : null;

        if (sku != null) {
            const $firstThumb = $wrapper.find(
                '.p-thumbnails-inner a.p-thumbnail, .p-thumbnails-inner a.p-video-thumbnail'
            ).first();

            if (!$main.find('.photoRecension').length) {
                $('<span></span>')
                    .addClass('photoRecension')
                    .attr('data-sku', sku)
                    .text(translation('nahratFotku'))
                    .appendTo($main);
            }

            // Přesuneme i tlačítko vytvořené před vložením videa.
            const $existingButtons = $wrapper.find(
                '.p-thumbnails-inner .photoRecension'
            );
            const $uploadButton = $existingButtons.first().detach();
            $existingButtons.slice(1).remove();

            if ($firstThumb.length) {
                ($uploadButton.length ? $uploadButton : $('<span></span>'))
                    .addClass('photoRecension')
                    .attr('data-sku', sku)
                    .text(translation('nahratFotku'))
                    .appendTo($firstThumb);
            }
        }

        [$wrapper, $('.p-info-wrapper').first()].forEach(function ($target) {
            if ($target.length && !$target.find('.photoRecensionInfo').length) {
                const $info = $('<div class="photoRecensionInfo"></div>');

                $('<img>').attr({
                    src: '/user/documents/upload/sablona-nemazat/ico/photoRecensionIcon.svg',
                    alt: 'Fotorecenze'
                }).appendTo($info);

                $('<p></p>').text(infoHlaskaRecenze).appendTo($info);
                $target.append($info);
            }
        });
    }

    if (!$inner.length) return;

    $wrapper.addClass('haveThumbnails');

    if (!$wrapper.children('.arrow-prev').length) {
        $wrapper.append(
            '<span class="arrow-prev"></span><span class="arrow-next"></span>'
        );
    }

    // Zachytíme šipky před běžnými obsluhami nativní galerie.
    const wrapperElement = $wrapper[0];
    if (wrapperElement.productMediaArrowHandler) {
        wrapperElement.removeEventListener(
            'click', wrapperElement.productMediaArrowHandler, true
        );
    }
    $wrapper.off('click.productMedia', '.arrow-prev, .arrow-next');

    wrapperElement.productMediaArrowHandler = function (e) {
        const $arrow = $(e.target).closest('.arrow-prev, .arrow-next');
        if (!$arrow.length || $arrow.closest('.p-image-wrapper')[0] !== wrapperElement) {
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        const $thumbs = $inner.find(
            'a.p-thumbnail, a.p-video-thumbnail, a.show360image'
        );
        if (!$thumbs.length) return;

        // Nativní skript může změnit highlighted ještě před kliknutím.
        // Použijeme položku, kterou skutečně zobrazil náš přehrávač.
        const currentIndex = $thumbs.index(
            wrapperElement.productMediaCurrentThumbnail
        );
        const isNext = $arrow.hasClass('arrow-next');
        const nextIndex = currentIndex < 0
            ? (isNext ? 0 : $thumbs.length - 1)
            : (currentIndex + (isNext ? 1 : -1) + $thumbs.length)
                % $thumbs.length;

        $inner.find('.highlighted').removeClass('highlighted');
        const $selected = $thumbs.eq(nextIndex).addClass('highlighted');

        updateMainImage($selected);
        if ($selected.hasClass('show360image')) {
            $selected.trigger('click');
        }
    };
    wrapperElement.addEventListener(
        'click', wrapperElement.productMediaArrowHandler, true
    );

    // Tři náhledy celkem: video případně zabere první pozici.
    const $videoThumb = $inner.find('a.p-video-thumbnail').first();
    const maxVisible = $videoThumb.length ? 2 : 3;
    const $photos = $inner.find('a.p-thumbnail:not(.p-video-thumbnail)');

    // Obnovíme původní obsah i při opakované inicializaci.
    $photos.removeClass('lastImage').show();
    $photos.find('.morePhotosBtn').remove();
    $photos.find('img').show();

    $photos.find('img').each(function () {
        const $img = $(this);
        const src = $img.attr('data-src');

        if (src && src.includes('/related/')) {
            $img.attr('data-src', src.replace('/related/', '/orig/'));
        }
    });

    $photos.slice(maxVisible + 1).hide();

    if ($photos.length > maxVisible) {
        const hiddenCount = $photos.length - maxVisible;
        const $moreThumb = $photos.eq(maxVisible).addClass('lastImage');

        // Obrázek ponecháme v DOM kvůli přepínání a popisku.
        $moreThumb.find('img').hide();

        if (!$moreThumb.find('.morePhotosBtn').length) {
            $('<span class="morePhotosBtn"></span>')
                .text('+ ' + hiddenCount + ' ' + sklonujFotky(hiddenCount))
                .appendTo($moreThumb);
        }
    }

    // Rozložení zahrnuje i náhled videa.
    $inner.find('a.p-thumbnail, a.p-video-thumbnail').each(function (i) {
        $(this)
            .removeClass('thumb-large thumb-small')
            .addClass(i === 0 ? 'thumb-large' : 'thumb-small');
    });

    // Výchozí položku určí hlavní obrázek, nikoli zvýraznění nativní galerie.
    const mainPhotoSrc = $mainLink.attr('href');
    let $initialPhoto = $photos.filter(function () {
        return $(this).attr('href') === mainPhotoSrc;
    }).first();
    if (!$initialPhoto.length) $initialPhoto = $photos.first();

    $inner.find('.highlighted').removeClass('highlighted');
    const $initialMedia = $videoThumb.length ? $videoThumb : $initialPhoto;
    $initialMedia.addClass('highlighted');
    wrapperElement.productMediaCurrentThumbnail = $initialMedia[0] || null;
    if ($initialMedia.length) updateMainImage($initialMedia);

});





    updatePriceSaveState();
  //  $(document).ready(initThumbnailLayout);


    

}

/*
$('body').on('click', '.p-thumbnail', function (e) {
    e.preventDefault();

    const $thumb = $(this);
    const $cbox = $thumb.next('.cbox-gal.cboxElement');

    // zvýraznění
    $('.p-thumbnail').removeClass('highlighted');
    $thumb.addClass('highlighted');

    // update hlavního obrázku
    updateMainImage($thumb);

    // 🔥 otevři Colorbox
    if ($cbox.length) {
        $cbox.trigger('click');
    }
});*/

$('body')
    .off('click.productMediaThumb', '.p-thumbnail, .p-video-thumbnail')
    .on('click.productMediaThumb', '.p-thumbnail, .p-video-thumbnail', function (e) {
        // Upload fotorecenze má vlastní obsluhu; neotevíráme galerii.
        if ($(e.target).closest('.photoRecension').length) return;
        e.preventDefault();

        const $thumb = $(this);
        const $wrapper = $thumb.closest('.p-image-wrapper');
        if (!$wrapper.length) return;

        if ($thumb.hasClass('p-video-thumbnail')) {
            e.stopImmediatePropagation();
            openProductVideo($thumb);
            return;
        }

        $wrapper.find('.p-thumbnails-inner .highlighted').removeClass('highlighted');
        $thumb.addClass('highlighted');
        updateMainImage($thumb);

        const $cbox = $thumb.next('a.cbox-gal');
        if ($cbox.length) {
            $cbox.trigger('click');
        } else {
            $wrapper.find('a.p-main-image.cbox').trigger('click');
        }
    });

function updateMainImage($thumb) {
    if (!$thumb || !$thumb.length) return;

    const $wrapper = $thumb.closest('.p-image-wrapper');
    const $main = $wrapper.find('.p-image').first();
    const $mainLink = $main.find('a.p-main-image').first();
    if (!$mainLink.length) return;

    $wrapper[0].productMediaCurrentThumbnail = $thumb[0];
    $wrapper.find('.p-thumbnails-inner .highlighted').removeClass('highlighted');
    $thumb.addClass('highlighted');

    $main.children('video.product-video').each(function () {
        this.pause();
        this.removeAttribute('src');
        this.load();
    }).remove();

    if ($thumb.hasClass('p-video-thumbnail')) {
        const video = document.createElement('video');
        video.className = 'product-video';
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        video.controls = !isMobile;
        video.loop = isMobile;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
        video.preload = 'metadata';
        video.style.cssText = 'display:block;width:100%;aspect-ratio:492/369;object-fit:contain;background:#000;';
        const poster = $thumb.attr('data-video-poster');
        if (poster) video.poster = poster;
        video.src = $thumb.attr('data-video-src');
        $mainLink.hide();
        $main.prepend(video);
        video.play().catch(function (error) {
            console.warn('Přehrávání hlavního videa:', error);
        });
        return;
    }

    $mainLink.show();
    if (!$thumb.hasClass('p-thumbnail')) return;
    const src = $thumb.attr('href');
    if (!$mainLink.length || !src) return;

    const alt = $thumb.attr('data-alt') ||
        $thumb.find('img').attr('alt') ||
        $thumb.next('a.cbox-gal').attr('data-alt') || '';

    $mainLink.show().attr({
        href: src,
        'data-href': $thumb.attr('data-full-image') || src,
        'data-alt': alt
    });

    $mainLink.find('img').removeAttr('srcset sizes').attr({
        src: src,
        'data-src': src,
        alt: alt
    });
}

function openProductVideo($thumb) {
    if (typeof $.colorbox !== 'function') {
        console.error('Colorbox není načtený.');
        return;
    }

    const $preview = $thumb.children('video');
    const resumePreview = $preview.length && !$preview[0].paused;
    if ($preview.length) $preview[0].pause();

    const $video = $('<video></video>').attr({
        class: 'product-video-popup',
        src: $thumb.attr('data-video-src'),
        controls: !window.matchMedia('(max-width: 767px)').matches,
        loop: window.matchMedia('(max-width: 767px)').matches,
        muted: window.matchMedia('(max-width: 767px)').matches,
        autoplay: true,
        playsinline: true,
        preload: 'metadata',
        style: 'display:block;width:100%;height:100%;object-fit:contain;background:#000;'
    });
    const poster = $thumb.attr('data-video-poster');
    if (poster) $video.attr('poster', poster);

    let popupVideo = null;

    $.colorbox({
        html: $video[0].outerHTML,
        width: '90%',
        maxWidth: '1000px',
        height: '80%',
        maxHeight: '800px',
        scrolling: false,
        returnFocus: false,
        onComplete: function () {
            popupVideo = $('#cboxLoadedContent video.product-video-popup')[0];
            if (!popupVideo) return;
            popupVideo.play().catch(function (error) {
                console.warn('Přehrávání v popupu:', error);
            });
        },
        onCleanup: function () {
            if (popupVideo) popupVideo.pause();
        },
        onClosed: function () {
            if (resumePreview && document.contains($preview[0])) {
                $preview[0].play().catch(function (error) {
                    console.warn('Přehrávání náhledu:', error);
                });
            }
        }
    });
}

function getVariantsData() {
    const variants = [];
    const hasMultipleVariants = $('#simple-variants label.advanced-parameter').length > 1;

    // ======================================
    // 🔹 JEDNA VARIANTA
    // ======================================
    if (!hasMultipleVariants) {

        const $priceFinalHolder = $('.p-final-price-wrapper .price-final-holder').first();
        const $priceStandard = $('.p-final-price-wrapper .price-standard').first();
        const $priceSave = $('.p-final-price-wrapper .price-save').first();
        const $availability = $('.availability-value .availability-label');

        const priceFinalText = $priceFinalHolder
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .trim();

        const priceFinal = getNumber(priceFinalText);

        const unit = $priceFinalHolder.find('.pr-list-unit').text().trim();

        const priceStandardText = $priceStandard.text().trim();
        const priceStandard = priceStandardText
            ? getNumber(priceStandardText)
            : null;

        const priceSaveText = $priceSave.text().trim();
        const priceSavePercent = priceSaveText.includes('%')
            ? parseInt(priceSaveText.replace(/[^\d]/g, ''), 10)
            : null;

        const stockText = $availability.text().trim();
        const stockColor = $availability.attr('style');

        const rawCode =
        $('.p-code .choose-variant').first().text().trim() ||
        $('.p-code').text().trim();

        const code = rawCode.replace(/[^\d]/g, '');

        const image =
            $('#simple-variants input[type="radio"]').data('detail_small') ||
            $('#simple-variants input[type="radio"]').data('big') ||
            $('.p-image img').first().attr('src');

        const name =
            $('#simple-variants label .advanced-parameter-inner').attr('title') ||
            $('.p-detail-inner-header h1').text().trim();

        variants.push({
            index: 1,
            code,
            price: priceFinal,
            unit,
            image,
            name,
            input: null,

            stock: stockText,
            stockColor,

            priceFinal,
            priceStandard,
            priceSavePercent,
            isSale: priceStandard !== null && priceFinal < priceStandard
        });

        return variants;
    }

    // ======================================
    // 🔹 VÍCE VARIANT (TVŮJ PŮVODNÍ KÓD)
    // ======================================
    $('#simple-variants label.advanced-parameter').each(function () {
        const $label = $(this);
        const $input = $label.find('input[type="radio"]');
        const index = $input.data('index');

        const $priceFinalHolder = getByIndexOrFallback(
            '.price-final-holder.choose-variant.' + index,
            '.price-final-holder'
        );

        const $priceStandardVariant = getByIndexOrFallback(
            '.price-standard .choose-variant.' + index + ':not(.default-variant)',
            '.price-standard .price-standard-holder'
        );

        const $priceSaveVariant = getByIndexOrFallback(
            '.price-save .choose-variant.' + index + ':not(.default-variant)',
            '.price-save'
        );

        const $availability = getByIndexOrFallback(
            '.p-info-wrapper .availability-value > span.' + index + ' .availability-label',
            '.p-info-wrapper .availability-label'
        );

        const $codeEl = getByIndexOrFallback(
    '.p-code .choose-variant.' + index,
    '.p-code'
);

const code = $codeEl
    .text()
    .replace('Kód:', '')
    .replace(/\s+/g, '')
    .trim();


        const priceFinalText = $priceFinalHolder
            .clone()
            .children()
            .remove()
            .end()
            .text()
            .trim();

        const priceFinal = getNumber(priceFinalText);

        const unit = $priceFinalHolder.find('.pr-list-unit').text().trim();

        const priceStandardText = $priceStandardVariant.text().trim();
        const priceStandard = priceStandardText && priceStandardText !== '–'
            ? getNumber(priceStandardText)
            : null;

        const priceSaveText = $priceSaveVariant.text().trim();
        const priceSavePercent = priceSaveText && priceSaveText.includes('%')
            ? parseInt(priceSaveText.replace(/[^\d]/g, ''), 10)
            : null;

        const image = $input.data('detail_small') || $input.data('big');
        const name = $label.find('.advanced-parameter-inner').attr('title');

        variants.push({
            index,
            code,
            price: priceFinal,
            unit,
            image,
            name,
            input: $input,

            stock: $availability.text().trim(),
            stockColor: $availability.attr('style'),

            priceFinal,
            priceStandard,
            priceSavePercent,
            isSale: priceStandard !== null && priceFinal < priceStandard
        });
    });

    return variants;
}



/*
function getStockFromDataLayer(code) {
    const dl = window.dataLayer?.find(d => d.shoptet?.product)?.shoptet;
    if (!dl || !dl.product || !Array.isArray(dl.product.codes)) return null;

    let variant = null;

    // jedna varianta → vezmi ji
    if (dl.product.codes.length === 1) {
        variant = dl.product.codes[0];
    } else if (code != null) {
        const normalizedCode = String(code).trim();
        variant = dl.product.codes.find(v => String(v.code) === normalizedCode);
    }

    if (!variant) return null;

    const stockMap = {};
    (variant.stocks || []).forEach(s => {
        stockMap[String(s.id)] = String(s.quantity).trim();
    });

    return {
        total: String(variant.quantity).trim(),
        eshop: stockMap['5'] ?? '0',
        store: stockMap['1'] ?? '0'
    };
}*/

function getStockFromDataLayer(code) {
    const dl = window.dataLayer?.find(d => d.shoptet?.product)?.shoptet;
    if (!dl || !dl.product || !Array.isArray(dl.product.codes)) return null;

    let variant = null;

    if (dl.product.codes.length === 1) {
        variant = dl.product.codes[0];
    } else if (code != null) {
        const normalizedCode = String(code).trim();
        variant = dl.product.codes.find(v => String(v.code) === normalizedCode);
    }

    if (!variant) return null;

    // map názvů skladů
    const stockTitles = {};
    (dl.stocks || []).forEach(s => {
        stockTitles[String(s.id)] = s.title;
    });

    const resultStocks = [];
    let totalQty = 0;

    (variant.stocks || []).forEach(s => {
            let rawQty = String(s.quantity).trim();

    // odstraní znak > a mezery
    rawQty = rawQty.replace(/[^\d]/g, '');

    const qty = parseInt(rawQty, 10) || 0;
        if (qty <= 0) return;

        totalQty += qty;

        resultStocks.push({
            id: s.id,
            title: stockTitles[String(s.id)] || `Sklad ${s.id}`,
            quantity: qty
        });
    });

    return {
        total: totalQty,
        inStock: totalQty > 0,
        stocks: resultStocks
    };
}




function renderChooseVariants() {
    const variants = getVariantsData();

    const availableVariants = variants.filter(v => !isNotInStock(v));
    const unavailableVariants = variants.filter(isNotInStock);
    //const unavailableVariants = variants.filter(v => !isInStock(v));
   
// pokud existuje aspoň jedna dostupná varianta

    const variantLabelsCount = $('#simple-variants label.advanced-parameter').length;
    const isSingleVariant = variantLabelsCount === 1;

    // 👉 skutečně vybraná varianta ze Shoptetu
    const checkedIndex = $('#simple-variants input[type="radio"]:checked').data('index');

    const $wrap = $(`
        <div class="chooseVariant">
            <div class="h3">${translation('variantTitle')}:</div>
            <div class="inner"></div>
        </div>
    `);

    const $inner = $wrap.find('.inner');

    function renderVariant(v) {
        const isActive =
            isSingleVariant ||
            (checkedIndex && String(v.index) === String(checkedIndex));

        let priceHtml = `
            <span class="priceFinal">
                ${Number(v.priceFinal).ShoptetFormatAsCurrency()} ${v.unit}
            </span>
        `;

        if (v.isSale && v.priceStandard) {
            priceHtml = `
                <span class="priceStandard isSaleBox">
                    ${Number(v.priceStandard).ShoptetFormatAsCurrency()}
                </span>
                <span class="priceFinal">
                    ${Number(v.priceFinal).ShoptetFormatAsCurrency()} ${v.unit}
                </span>
            `;
        }

        const saleBadge = v.isSale && v.priceSavePercent
            ? `<span class="saleBadge">-${v.priceSavePercent}%</span>`
            : '';

        return $(`
            <div class="chooseVariantItem ${isActive ? 'active' : ''}" data-index="${v.index}">
                <div class="img">
                    ${saleBadge}
                    <img src="${v.image}" alt="" loading="eager">
                </div>
                <div class="info">
                    <div class="name">${v.name}</div>
                    <div class="bottomMargin">
                        <div class="stock">
                            <span style="${v.stockColor}">${v.stock}</span>
                        </div>
                        <div class="price">
                            ${priceHtml}
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    // =========================
    // 🔹 RENDER
    // =========================


    availableVariants.forEach(v => { $inner.append(renderVariant(v)); }); 
    
    unavailableVariants.forEach(v => { $inner.append(renderVariant(v)); });

    $('.p-info-wrapper').append($wrap);
    
    let $activeItem = $('.chooseVariantItem.active');

    // pokud jsme našli lepší dostupnou variantu → přepni ji
    

    // teď už vždy bereme správnou variantu
    if ($activeItem.length) {
        const index = $activeItem.data('index');
        const variant = variants.find(v => String(v.index) === String(index));
        
if (variant) {
    updateStockInfo(variant.code);
}
    }
}



$(document).on('click', '.chooseVariantItem', function () {
    const index = $(this).data('index');
    // přepnutí skutečné varianty
    $('#simple-variants input[data-index="' + index + '"]').trigger('click');

    $('.chooseVariantItem').removeClass('active');
    $(this).addClass('active');

    const variant = getVariantsData().find(v =>
        String(v.index) === String(index)
    );

    if (variant) {
        updateStockInfo(variant.code);
    }
    setTimeout(updatePriceSaveState, 0);
});

function getAllStockTitles() {
    const product = dataLayer.find(item => item.shoptet?.product);
    if (!product || !product.shoptet.product.stocks) return [];

    return product.shoptet.product.stocks.map(s => s.title);
}

function createStockInfoBlock() {

    if ($('.customStockLine').length) return;

    let rowsHtml = '';

    // najdeme shoptet objekt v dataLayer
    const dlItem = dataLayer.find(item => item.shoptet && item.shoptet.stocks);
  
    if (dlItem && dlItem.shoptet.stocks.length) {

        dlItem.shoptet.stocks.forEach(s => {

            if (s.visibleOnEshop) {
               
                rowsHtml += `
                    <div class="lineRow" data-stock-id="${s.id}">
                        <strong>${s.title}:</strong>
                        <span>-</span>
                    </div>
                `;

            }

        });
    }

    // fallback (kdyby něco selhalo)
    if (!rowsHtml) {
        rowsHtml = `
            <div class="lineRow">
                <strong>${translation('stock')}:</strong>
                <span>-</span>
            </div>
        `;
    }

    const html = `
        <div class="customStockLine">
            <div class="left">
                <div class="inner">
                    ${rowsHtml}
                </div>
            </div>
            <div class="right">
                <span class="delivery-link"></span>
                <a href="${$('.link-icons .watchdog').attr('href')}" 
                   class="link-icon watchdog" 
                   style="display:none" 
                   rel="nofollow" 
                   title="${translation('hlidat')}">
                   ${translation('hlidat')}
                </a>
            </div>
        </div>
    `;

    $('.p-info-wrapper').append(html);
}




/*
function updateStockInfo(code) {

    const stock = getStockFromDataLayer(code);
    if (!stock) return;

    const $customStock = $('.customStockLine');
    const $inner = $customStock.find('.inner');

    const eshopQty = String(stock.eshop).trim();
    const storeQty = String(stock.store).trim();

    const isInStock = !(eshopQty === '0' && storeQty === '0');

    // ===============================
    // ❌ NENÍ SKLADEM (DL)
    // ===============================

    const availability = getActiveVariantStockText();
    if (!isInStock) {

    

    $customStock.addClass('disabledStock');
    $('.social-buttons-wrapper').hide();

    $inner.html(`
        <div class="availabilityText" style="color:#cb0000">
            ${availability.text}
        </div>
    `);

    $('.delivery-link').hide();
    $('.watchdog').show();
    return;
}


    // ===============================
    // ✅ JE SKLADEM
    // ===============================
    $customStock.removeClass('disabledStock');
    $('.social-buttons-wrapper').show();
    if (!$inner.find('.js-stock-eshop').length) {
       
        $inner.html(`
            <div class="lineRow">
                <strong>${translation('stockEshop')}:</strong>
                <span class="js-stock-eshop" style="color:#59822E"></span>
            </div>
            <div class="lineRow">
                <strong>${translation('stockProdejna')}:</strong>
                <span class="js-stock-store" style="color:#59822E"></span>
            </div>
        `);
    }

    $('.js-stock-eshop').text(eshopQty+' ks').attr('style', 'color:#59822E');
    $('.js-stock-store').text(storeQty+' ks').attr('style', 'color:#59822E');

    $('.delivery-link').show();
    $('.watchdog').hide();
}*/

function updateStockInfo(code) {
    console.log(code)
    const stock = getStockFromDataLayer(code);
    if (!stock) return;

    const $customStock = $('.customStockLine');
    const $inner = $customStock.find('.inner');

    const availability = getActiveVariantStockText();
 //  console.log(availability)
   
    // ===============================
    // ❌ NENÍ SKLADEM
    // ===============================
    if (!stock.inStock) {

        $customStock.addClass('disabledStock');
        $('.social-buttons-wrapper').hide();

        $inner.html(`
            <div class="availabilityText" style="color:#cb0000">
                ${availability.text}
            </div>
        `);

        $('.delivery-link').hide();
        $('.watchdog').show();
        return;
    }

    // ===============================
    // ✅ JE SKLADEM
    // ===============================
    $customStock.removeClass('disabledStock');
    $('.social-buttons-wrapper').show();

    let rowsHtml = '';

    stock.stocks.forEach(s => {
        
        rowsHtml += `
            <div class="lineRow" data-stock-id="${s.id}">
                <strong>${s.title}:</strong>
                <span style="color:#59822E">${s.quantity} ks</span>
            </div>
        `;
    });

    // fallback – kdyby byl skladem, ale žádný sklad neměl qty (edge-case)
    if (!rowsHtml) {
        rowsHtml = `
            <div class="availabilityText" style="color:#59822E">
                ${availability.text}
            </div>
        `;
    }

    $inner.html(rowsHtml);

    $('.delivery-link').show();
    $('.watchdog').hide();
}



function getNumber(value) {
    return parseFloat(
        value
            .replace(/\s/g, '')     // odstraní mezery
            .replace(',', '.')      // čárku na tečku
            .replace(/[^\d.]/g, '') // vše kromě čísla a tečky pryč
    );
}

function isInStock(variant) {
    return variant.stock?.toLowerCase().includes(translation('helperSkladem'));
}

function isNotInStock(variant) {
    const stockText = normalizeStockText(variant.stock);

    return NOT_IN_STOCK_STATES.some(state =>
        stockText.includes(normalizeStockText(state))
    );
}


function updatePriceSaveState() {
    const $wrapper = $('.p-final-price-wrapper');

    // ===== JEDNA VARIANTA =====
    if (!hasMultipleVariants()) {
        const text = $wrapper.find('.price-save').text().trim();

        const hasDiscount =
            text !== '' &&
            text !== '-' &&
            text.includes('%');

        $wrapper.toggleClass('hasDiscount', hasDiscount);
        return;
    }

    // ===== VÍCE VARIANT =====
    const $activeFinal = $wrapper.find(
        '.price-final-holder.choose-variant:not(.no-display):not(.default-variant)'
    ).first();

    if (!$activeFinal.length) {
        $wrapper.removeClass('hasDiscount');
        return;
    }

    const index = $activeFinal
        .attr('class')
        .split(' ')
        .find(c => /^\d+$/.test(c));

    if (!index) {
        $wrapper.removeClass('hasDiscount');
        return;
    }

    const $priceSave = $wrapper.find(
        `.price-save .choose-variant.${index}`
    );

    const hasDiscount =
        $priceSave.length &&
        !$priceSave.hasClass('empty') &&
        !$priceSave.hasClass('no-display') &&
        $priceSave.text().trim() !== '-' &&
        $priceSave.text().trim() !== '';

    $wrapper.toggleClass('hasDiscount', hasDiscount);
}


function updatePriceSaveStateOnLoad() {
    const $wrapper = $('.p-final-price-wrapper');

    // ===== JEDNA (nebo žádná) VARIANTA =====
    if (!hasMultipleVariants()) {
        const text = $wrapper.find('.price-save').text().trim();

        const hasDiscount =
            text !== '' &&
            text !== '-' &&
            text.includes('%');

        $wrapper.toggleClass('hasDiscount', hasDiscount);
        return;
    }

    // ===== VÍCE VARIANT → DEFAULT =====
    const $defaultSave = $wrapper.find(
        '.price-save .choose-variant.default-variant'
    );

    if (!$defaultSave.length) {
        $wrapper.removeClass('hasDiscount');
        return;
    }

    const hasDiscount =
        $defaultSave.text().trim() !== '' &&
        $defaultSave.text().trim() !== '-' &&
        !$defaultSave.hasClass('empty');

    $wrapper.toggleClass('hasDiscount', hasDiscount);
}


function hasMultipleVariants() {
    return $('#simple-variants label.advanced-parameter').length > 1;
}



function getActiveVariantStockText() {
    const $active = $('.chooseVariantItem.active');

    if ($active.length) {
        return {
            text: $active.find('.stock span').text().trim(),
            color: $active.find('.stock span').attr('style') || ''
        };
    }
    else{
        return {
            text: $('.availability-value>span').first().text().trim(),
            color: $('.availability-value>span').first().attr('style')
        }
    }

  
    
}

function sklonujFotky(count) {
    if (count === 1) return translation('dalsifotografie');
    if (count >= 2 && count <= 4) return translation('dalsifotografie');
    return translation('dalsichFotografii');
}

function slugify(str) {
    return str
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

$('html').on('click', 'a.shipping-options', function (e) {
    e.preventDefault();
    const waitForPopup = setInterval(function () {
        const $popup = $('.shipping-options-popup');
        if (!$popup.length) return;
        clearInterval(waitForPopup);
        const zoneNames = deliveryZonesConfig.map(z => z.name);
        const minPrice = Math.min.apply(null, deliveryZonesConfig.map(z => z.price));
        let foundAnyZone = false;
        $popup.find('.shipping-row').each(function () {
            const $row = $(this);
            const name = $row.find('.shipping-billing-name').text().trim();
            if (zoneNames.includes(name)) {
                foundAnyZone = true;
                $row.remove();
            }
            if ($(this).find('.shipping-billing-name').text().includes('Rozdělení objednávky')) {
                
                $row.remove();
            }

        });
        if (foundAnyZone) {
            const formattedPrice = minPrice;
            const mergedRow = `
                <div class="shipping-row shipping-row--merged">
                    <span class="payment-info">
                        <b class="shipping-billing-name">${preprava}</b>
                    </span>
                    <strong class="payment-shipping-price">${translation('od')} ${Number(formattedPrice).ShoptetFormatAsCurrency()}</strong>
                </div>
            `;
            $popup.append(mergedRow);
        }

    }, 1);
});


function getByIndexOrFallback(selectorByIndex, selectorFallback) {
    const $byIndex = $(selectorByIndex);
    return $byIndex.length
        ? $byIndex.first()
        : $(selectorFallback).first();
}

function initQuantityDiscountInfo($wrap) {
    
    var $discountWrap = $wrap.find('.quantity-discounts');
    if (!$discountWrap.length) return;

    var $amountInput = $wrap.find("input[name='amount']");
    var $increase = $wrap.find(".increase");
    var $decrease = $wrap.find(".decrease");

    var discounts = [];
    var basePrice = parseFloat($discountWrap.find('.quantity-discounts__table').data('orig-price'));

   $discountWrap.find('.quantity-discounts__item').each(function () {
        var $itemData = $(this);
        var rawText = $itemData.find('.quantity-discounts__title').text();
        var cleanText = rawText
            .replace(/\u00a0/g, ' ')   // &nbsp;
            .replace(/\s+/g, ' ')      // vícenásobné mezery
            .trim();
        var textSplit = cleanText.split('=');
        var name = textSplit[0] ? textSplit[0].trim() : '';
        var sale = '';
        if (textSplit[1]) {
            var match = textSplit[1].match(/(\d+)\s*%/);
            if (match) {
                sale = '-' + match[1] + '%';
            }
        }
        $itemData.find('.quantity-discounts__title').html(
            '<span class="name">' + name + '</span>' +
            (sale ? '<span class="sale">' + sale + '</span>' : '')
        );
        discounts.push({
            amount: parseInt($itemData.data('amount'), 10),
            ratio: parseFloat($itemData.data('price-ratio')),
            price: Math.round(basePrice * parseFloat($itemData.data('price-ratio')))
        });
    });

    discounts.sort((a, b) => a.amount - b.amount);

    var $infoBox = $('<div class="qtyDiscountInfo"></div>');
    $('.p-info-wrapper').append($infoBox);

    function getCurrentTier(qty) {
        var current = discounts[0];
        discounts.forEach(function (d) {
            if (qty >= d.amount) current = d;
        });
        return current;
    }

    function getNextTier(qty) {
        for (var i = 0; i < discounts.length; i++) {
            if (discounts[i].amount > qty) {
                return discounts[i];
            }
        }
        return null;
    }

    function renderInfo(qty) {
        if (qty <= 0) {
            $infoBox.html('');
            return;
        }

        var current = getCurrentTier(qty);
        var next = getNextTier(qty);

        var savedNow = Math.max(0, (basePrice - current.price) * qty);

        var html = `
            ${translation('nyniUsetrite')} <strong>${Number(savedNow).ShoptetFormatAsCurrency()}.</strong>
        `;

        if (next) {
            var diff = next.amount - qty;
            var savePerItem = current.price - next.price;

            html += `
                ${translation('pridejtejeste')} <strong>${diff} ${translation('ks')}</strong> 
                ${translation('usetrite')} <strong class="green">${Number(savePerItem).ShoptetFormatAsCurrency()} / ${translation('ks')}</strong>.
            `;
        } else {
            html += `${translation('nejlepsicena')}`;
        }

        $infoBox.html(html);
    }

    function getQty() {
        return parseInt($amountInput.val(), 10) || 0;
    }

    $increase.on('click', function () {
        renderInfo(getQty() + 1);
    });

    $decrease.on('click', function () {
        renderInfo(Math.max(0, getQty() - 1));
    });

    $amountInput.on('input change', function () {
        renderInfo(getQty());
    });

    renderInfo(getQty());

    $discountWrap.on('click', '.quantity-discounts__item', function () {
        var qty = parseInt($(this).data('amount'), 10);
        if (!qty || isNaN(qty)) return;
        $amountInput.val(qty).trigger('change');
        renderInfo(qty);
    });

}

function normalizeStockText(text) {
    return (text || '')
        .toString()
        .toLowerCase()
        .trim();
}


if($('.type-detail').length){
    if(!$('.product-top .flag-blok-recenze').length){
        $('.p-image').append(`
            <span class="photoRecension" data-sku=${getShoptetDataLayer('product').codes[0].code}>${translation('nahratFotku')}</span>    
        `);
        $('.p-thumbnails-wrapper .p-thumbnails-inner a.p-thumbnail').first().append(`
            <span class="photoRecension" data-sku=${getShoptetDataLayer('product').codes[0].code}>${translation('nahratFotku')}</span>    
        `);
        $('.p-image-wrapper').append(`
            <div class="photoRecensionInfo">
                <img src="/user/documents/upload/sablona-nemazat/ico/photoRecensionIcon.svg" alt="Fotorecenze">
                <p>${infoHlaskaRecenze}</p>
            </div>
        `)
        $('.p-info-wrapper').append(`
            <div class="photoRecensionInfo">
                <img src="/user/documents/upload/sablona-nemazat/ico/photoRecensionIcon.svg" alt="Fotorecenze">
                <p>${infoHlaskaRecenze}</p>
            </div>
        `)
    }
}